import * as ActionType from "./showcase.type";

const initialState = {
  showcase: [],
};

export const showcaseReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.GET_SHOWCASE:
      return { ...state, showcase: action.payload };

    case ActionType.CREATE_SHOWCASE:
      let data = [...state.showcase];
      data.unshift(action.payload);
      return { ...state, showcase: data };

    case ActionType.UPDATE_SHOWCASE:
      return {
        ...state,
        showcase: state.showcase.map((item) =>
          item._id === action.payload.id ? action.payload.data : item
        ),
      };

    case ActionType.DELETE_SHOWCASE:
      return {
        ...state,
        showcase: state.showcase.filter((item) => item._id !== action.payload),
      };

    default:
      return state;
  }
};
